<!-- 自定义配置 -->
<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="样式" name="2">
        <el-form-item label="线条样式">
          <avue-select
            v-model="main.activeOption.lineType"
            :dic="dicOption.lineType"
          >
          </avue-select>
        </el-form-item>
        <el-form-item label="线条颜色">
          <avue-input-color
            v-model="main.activeOption.color"
          ></avue-input-color>
        </el-form-item>
        <el-form-item label="填充色">
          <avue-input-color
            v-model="main.activeOption.fillColor"
          ></avue-input-color>
        </el-form-item>
        <el-form-item label="线条宽度">
          <avue-input-number
            v-model="main.activeOption.lineWidth"
            :max="200"
            :min="1"
          ></avue-input-number>
        </el-form-item>
        <template v-if="main.activeOption.lineType != 'solid'">
          <el-form-item label="线条动画">
             <avue-select
            v-model="main.activeOption.lineAnimation"
            :dic="dicOption.lineAnimation"
          >
          </avue-select>
          </el-form-item>
        </template>
        <template v-if="main.activeOption.lineAnimation != '' && main.activeOption.lineType != 'solid'">
          <el-form-item label="流向">
             <avue-radio v-model="main.activeOption.lineFlow"
                  :dic="dicOption.lineFlow"></avue-radio>
          </el-form-item>
        </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { dicOption } from "@/option/config";
export default {
  inject: ["main"],
  data() {
    return {
      activeNames: ["2"],
      dicOption: dicOption,
    };
  },
};
</script>

<style>
</style>